import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Instagram, Mail } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="px-6 py-24 md:py-32 max-w-7xl mx-auto" data-id="element-30">
      <div className="max-w-4xl mx-auto text-center" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-32">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-serif mb-8 text-[#4A3B47]" data-id="element-33">
            Ready to make your brand feel like{' '}
            <span className="italic text-[#A88B9D]" data-id="element-34">home</span>?
          </h2>

          <p className="text-xl text-[#4A3B47]/70 max-w-2xl mx-auto mb-12" data-id="element-35">
            Let's create a space where your customers want to stay. Reach out
            and let's start a conversation about your vision.
          </p>

          <a href="mailto:underlinedbydania@gmail.com" className="text-lg text-[#4A3B47] hover:text-[#A88B9D] transition-colors font-medium" data-id="element-36">
            underlinedbydania@gmail.com
          </a>

          <div className="flex items-center justify-center gap-8 mt-10 pt-8 border-t border-[#4A3B47]/10" data-id="element-37">
            <a href="https://www.linkedin.com/in/underlinedbydania/" target="_blank" rel="noopener noreferrer" className="text-[#4A3B47]/60 hover:text-[#A88B9D] transition-colors" aria-label="LinkedIn" data-id="element-38">
              <Linkedin className="w-6 h-6" data-id="element-39" />
            </a>
            <a href="https://www.instagram.com/underlinedbydania/" target="_blank" rel="noopener noreferrer" className="text-[#4A3B47]/60 hover:text-[#A88B9D] transition-colors" aria-label="Instagram" data-id="element-40">
              <Instagram className="w-6 h-6" data-id="element-41" />
            </a>
            <a href="mailto:underlinedbydania@gmail.com" className="text-[#4A3B47]/60 hover:text-[#A88B9D] transition-colors" aria-label="Email" data-id="element-42">
              <Mail className="w-6 h-6" data-id="element-43" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}